<template>
  <v-card class="card-container">
    <div class="main-toolbar">
      <div class="icon-back">
        <v-img
          src="../../../../../assets/figmaIcons/white/stock.svg"
          max-width="55%"
        ></v-img>
      </div>

      <span class="main-toolbar-title">{{
        $t('Natureza do Custo Evitado')
      }}</span>

      <v-spacer></v-spacer>
    </div>

    <div class="d-flex justify-end mt-4">
      <v-btn class="secondary-button mr-4" depressed @click="openCreate">
        {{ $t('Novo') }}
      </v-btn>
      <v-btn class="primary-button mr-0" depressed @click="show = !show">
        {{ show ? $t('Fechar') : $t('Filtros') }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="show">
        <v-form ref="form">
          <v-row class="ma-0" align="center" justify="end" dense>
            <v-col cols="auto">
              <span class="text ml-1">{{ $t('Natureza') }}</span>
              <v-text-field
                v-model="filter.nature"
                hide-details="auto"
                class="primary-input"
                :placeholder="$t('Pesquisar por natureza')"
                outlined
                @keyup.enter="applyFilter"
                append-icon="mdi-magnify"
              >
              </v-text-field>
            </v-col>

            <v-col cols="auto">
              <span class="text ml-1">{{ $t('Data de Criação') }}</span>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="filter.startDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    :placeholder="$t('Selecionar período')"
                    prepend-icon=""
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="primary-input"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateRange"
                  no-title
                  scrollable
                  range
                  @input="updateDateRange"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    {{ $t('Cancelar') }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(dateRange)"
                  >
                    {{ $t('OK') }}
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <div class="d-flex justify-end">
            <v-btn class="clear-button mr-2" depressed @click="reset">
              {{ $t('Limpar') }}
            </v-btn>
            <v-btn @click="applyFilter" class="secondary-button" depressed>
              {{ $t('Aplicar filtros') }}
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="filter.pageSize"
      class="main-table"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
      :loading="loading"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.natureza`]="{ item }">
        <span class="font-weight-medium">{{ item.natureza }}</span>
      </template>

      <template #[`item.createdAt`]="{ item }">
        <span>{{ formatDate(item.createdAt) }}</span>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              small
              depressed
              @click="openEdit(item)"
              v-on="on"
            >
              <v-icon size="22">mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#921616"
              depressed
              small
              dark
              @click="openDelete(item)"
              v-on="on"
            >
              <v-icon size="22">mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="filter.pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="items.length">
          <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
          <br />
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>

    <!-- Modal de Cadastro/Edição seguindo o padrão -->
    <v-dialog v-model="formDialog" max-width="700" persistent>
      <v-card class="card-pad mx-auto">
        <v-dialog v-model="alterDialog" max-width="300px">
          <div class="text-center">
            <v-sheet
              class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
              color="blue-grey darken-3"
              dark
            >
              <div class="grey--text text--lighten-1 text-body-2 mb-4">
                {{
                  $t('Os dados informados não serão salvos, deseja continuar?')
                }}
              </div>

              <v-btn
                depressed
                :disabled="saving"
                class="ma-1"
                color="grey"
                text
                @click="alterDialog = false"
              >
                {{ $t('Não') }}
              </v-btn>

              <v-btn
                depressed
                :loading="saving"
                class="ma-1"
                color="#B14949"
                text
                @click="closeDialog"
              >
                {{ $t('Sim') }}
              </v-btn>
            </v-sheet>
          </div>
        </v-dialog>

        <v-btn absolute top right depressed dark icon @click="close">
          <v-icon color="#bbb">mdi-close</v-icon>
        </v-btn>

        <div class="d-flex align-center justify-center my-3">
          <h2>{{ $t(currentTitle) }}</h2>
          <v-alert
            type="error"
            v-show="error"
            transition="scale-transition"
            icon="mdi-alert-octagon-outline"
          >
            {{ $t(errorMessage) }}
          </v-alert>
        </div>

        <v-window v-model="step" touchless>
          <v-window-item :value="0">
            <v-form
              class="form"
              ref="firstForm"
              v-model="firstValid"
              lazy-validation
            >
              <v-row class="ma-0 mx-6" dense justify="end">
                <v-col cols="12">
                  <label class="label ml-1">{{
                    $t('Natureza do Custo Evitado')
                  }}</label>
                  <v-text-field
                    hide-details="auto"
                    v-model="form.nature"
                    :rules="natureRules"
                    required
                    outlined
                    class="primary-input"
                    :placeholder="
                      $t(
                        'Ex: Cancelamento de Contrato, Redução de Custo do Contrato, Reparo de Acessórios...'
                      )
                    "
                  >
                    <template #message="{ message }">
                      {{ $t(message) }}
                    </template>
                  </v-text-field>
                </v-col>

                <v-col cols="12" v-if="isEditing">
                  <v-alert type="info" outlined dense class="mt-2">
                    <small>
                      {{ $t('Criado em') }}: {{ formatDate(form.createdAt) }}
                      <br
                        v-if="
                          form.updatedAt && form.updatedAt !== form.createdAt
                        "
                      />
                      <span
                        v-if="
                          form.updatedAt && form.updatedAt !== form.createdAt
                        "
                      >
                        {{ $t('Última atualização') }}:
                        {{ formatDate(form.updatedAt) }}
                      </span>
                    </small>
                  </v-alert>
                </v-col>
              </v-row>
            </v-form>
          </v-window-item>

          <v-window-item :value="1">
            <div class="fill-height text-center pa-8">
              <v-icon size="60" color="success">
                mdi-checkbox-marked-circle
              </v-icon>

              <span style="display: block; margin-top: 10px; font-size: 1.2rem">
                {{
                  isEditing
                    ? $t('Natureza atualizada com sucesso!')
                    : $t('Natureza cadastrada com sucesso!')
                }}
              </span>
            </div>
          </v-window-item>
        </v-window>

        <v-divider class="mb-6 mt-2 mx-8"></v-divider>

        <div class="d-flex mx-6">
          <v-btn
            depressed
            @click="close"
            v-if="step === 0"
            class="secondary-button"
          >
            {{ $t('Cancelar') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="primary-button mr-0"
            @click="next"
            :loading="saving"
          >
            {{ $t(buttonText) }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Modal de Confirmação de Exclusão -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <v-icon size="48" color="warning" class="mb-4">
            mdi-alert-circle-outline
          </v-icon>

          <div class="grey--text text--lighten-1 text-body-1 mb-2">
            {{ $t('Excluir Natureza') }}
          </div>

          <div class="white--text font-weight-bold mb-4">
            "{{ selectedItem?.natureza }}"
          </div>

          <div class="grey--text text--lighten-1 text-body-2 mb-6">
            {{ $t('Esta ação não pode ser desfeita. Tem certeza?') }}
          </div>

          <v-btn
            :disabled="deleting"
            class="ma-1"
            color="grey"
            text
            @click="deleteDialog = false"
          >
            {{ $t('Cancelar') }}
          </v-btn>

          <v-btn
            :loading="deleting"
            class="ma-1"
            color="error"
            @click="confirmDelete"
          >
            {{ $t('Excluir') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  data() {
    return {
      institutionId: null,
      apiService: new ApiService(),
      show: false,
      menu: false,
      loading: false,
      saving: false,
      deleting: false,
      formDialog: false,
      deleteDialog: false,
      alterDialog: false,
      formKey: 0,
      deleteKey: 0,
      step: 0,
      firstValid: true,
      isEditing: false,
      selectedItem: null,
      changedData: false,
      error: false,
      errorMessage: '',
      currentTitle: '',
      filter: {
        natureza: '',
        startDate: null,
        endDate: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      },
      dateRange: [],
      items: [],
      sizes: [10, 25, 50, 100],
      headers: [
        {},
        {
          text: 'Natureza do Custo Evitado',
          value: 'nature',
          sortable: true,
          align: 'center',
        },
        {
          text: 'Data de Criação',
          value: 'createdAt',
          sortable: true,
          align: 'center',
        },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
      ],

      form: {
        nature: '',
        description: '',
        institutionId: null,
        createdAt: null,
        updatedAt: null,
      },

      natureRules: [
        (v) => !!v || this.$t('Natureza é obrigatória'),
        (v) =>
          (v && v.length <= 100) ||
          this.$t('Natureza deve ter no máximo 100 caracteres'),
        (v) =>
          (v && v.length >= 3) ||
          this.$t('Natureza deve ter no mínimo 3 caracteres'),
      ],
    }
  },

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
  },

  computed: {
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length === 0) return ''
      if (this.dateRange.length === 1) return this.formatDate(this.dateRange[0])
      return `${this.formatDate(this.dateRange[0])} - ${this.formatDate(
        this.dateRange[1]
      )}`
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  mounted() {
    this.loadData()
  },

  watch: {
    'filter.page'() {
      this.loadData()
    },
    'filter.pageSize'() {
      this.filter.page = 1
      this.loadData()
    },
    form: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },

  methods: {
    async loadData() {
      this.filter.institutionId = this.institutionId
      this.apiService
        .post('AvoidedCostNature/list/paginate', this.filter)
        .then((response) => {
          this.loading = false
          this.items = response.content.data

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
        .catch(() => {
          this.loading = false
        })
    },

    applyFilter() {
      this.filter.page = 1
      this.loadData()
    },

    reset() {
      this.filter = {
        natureza: '',
        startDate: null,
        endDate: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      }
      this.dateRange = []
      this.loadData()
    },

    updateDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.filter.startDate = this.dateRange[0]
        this.filter.endDate = this.dateRange[1] || this.dateRange[0]
      } else {
        this.filter.startDate = null
        this.filter.endDate = null
      }
    },

    openCreate() {
      this.isEditing = false
      this.step = 0
      this.currentTitle = 'Nova Natureza'
      this.resetForm()
      this.formDialog = true
      this.formKey++
    },

    openEdit(item) {
      this.isEditing = true
      this.step = 0
      this.currentTitle = 'Editar Natureza'
      this.selectedItem = item
      this.form = { ...item }
      this.formDialog = true
      this.formKey++
    },

    openDelete(item) {
      this.selectedItem = item
      this.deleteDialog = true
      this.deleteKey++
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.closeDialog()
      }
    },

    closeDialog() {
      this.formDialog = false
      this.alterDialog = false
      this.changedData = false
      this.step = 0
      this.error = false
      this.resetForm()
      if (this.$refs.firstForm) {
        this.$refs.firstForm.resetValidation()
      }
    },

    resetForm() {
      this.form = {
        nature: '',
        description: '',
        createdAt: null,
        updatedAt: null,
      }
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          await this.submit()
          if (!this.error) {
            this.step += 1
          }
        }
      } else {
        this.closeDialog()
        this.loadData()
      }
    },

    async submit() {
      try {
        this.saving = true
        this.error = false

        this.form.institutionId = this.institutionId

        console.log(this.form)
        if (this.isEditing) {
          await this.apiService
            .put('AvoidedCostNature/edit', this.form)
            .then(() => {})
            .catch(() => {
              this.saving = false
            })
        } else {
          await this.apiService
            .post('AvoidedCostNature/add', this.form)
            .then(() => {})
            .catch(() => {
              this.saving = false
            })
        }

        this.changedData = false
      } catch (error) {
        console.error('Erro ao salvar:', error)
        this.error = true
        this.errorMessage = error.message || 'Erro ao salvar natureza'

        setTimeout(() => {
          this.error = false
        }, 4000)
      } finally {
        this.saving = false
      }
    },

    async confirmDelete() {
      try {
        this.deleting = true

        this.apiService
          .delete(`AvoidedCostNature/delete?id=${this.selectedItem.id}`)
          .then(() => {
            this.showSnackbar('Natureza excluída com sucesso!', 'success')
            this.deleteDialog = false
            this.selectedItem = null
            this.loadData()
          })
          .catch(() => {
            this.deleting = false
          })
      } catch (error) {
        this.showSnackbar('Erro ao excluir natureza', 'error')
      } finally {
        this.deleting = false
      }
    },

    formatDate(date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('pt-BR')
    },

    showSnackbar(text, color = 'success') {
      this.snackbar = {
        show: true,
        text,
        color,
        timeout: 4000,
      }
    },
  },
}
</script>

<style scoped>
.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>
